module.exports = __webpack_public_path__ + "img/instagram.a30c2c78.svg";